export default "__VITE_ASSET__BS$Wyexo__"